import React, { useState } from 'react';
import { AlertTriangleIcon, CheckIcon, ChevronDownIcon, XIcon } from 'lucide-react';
import type { SeoCheck } from '../../data/seo';
import { Card } from '../ui/Card';
interface SeoChecklistProps {
  checks: SeoCheck[];
}
const statusStyles = {
  pass: {
    icon: CheckIcon,
    ring: 'bg-grow/15 text-grow',
    label: 'Good'
  },
  warn: {
    icon: AlertTriangleIcon,
    ring: 'bg-[#d97742]/15 text-[#e8a369]',
    label: 'Could improve'
  },
  fail: {
    icon: XIcon,
    ring: 'bg-danger/15 text-danger',
    label: 'Needs attention'
  }
} as const;
export function SeoChecklist({
  checks
}: SeoChecklistProps) {
  const [openId, setOpenId] = useState<string | null>(checks.find(check => check.status !== 'pass')?.id ?? null);
  return <Card className="p-4" data-id="element-542" data-mp="1w2hz1hw2miyv">
      <ul className="divide-y divide-white/[0.06]" data-id="element-543" data-mp="1w1qb8t8ptpj5">
        {checks.map(check => {
        const {
          icon: Icon,
          ring,
          label
        } = statusStyles[check.status];
        const isOpen = openId === check.id;
        return <li key={check.id} className="first:-mt-1 last:-mb-1" data-id="element-544" data-mp="n492yp8zioa7">
              <button type="button" onClick={() => setOpenId(isOpen ? null : check.id)} aria-expanded={isOpen} className="flex w-full items-center gap-3 py-3 text-left" data-id="element-545" data-mp="n6lu9t0muazx">
                <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full ${ring}`} data-id="element-546" data-mp="8ge8p4fbwbv0">
                  <Icon className="h-3.5 w-3.5" strokeWidth={2.5} data-id="element-547" data-mp="162bxfjkaxdfe" />
                </span>
                <span className="min-w-0 flex-1" data-id="element-548" data-mp="1140n77q3h0wn">
                  <span className="block text-[13.5px] font-medium text-white" data-id="element-549" data-mp="1127gxtje8ip6">{check.label}</span>
                  <span className="block truncate text-[12px] text-zinc-500" data-id="element-550" data-mp="w7a4ecmwnr7j">{check.finding}</span>
                </span>
                <span className="hidden shrink-0 text-[11px] font-medium uppercase tracking-wide text-zinc-600 sm:block" data-id="element-551" data-mp="3gv6claczwss8">
                  {label}
                </span>
                <ChevronDownIcon className={`h-4 w-4 shrink-0 text-zinc-600 transition-transform duration-150 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-552" data-mp="3cvxiu5hyguwo" />
              </button>

              {isOpen && <div className="ml-9 space-y-2 pb-4 pr-2" data-id="element-553" data-mp="34dc0nb1rlybk">
                  <p className="text-[12.5px] leading-relaxed text-zinc-400" data-id="element-554" data-mp="34ewxj7bjxtcl">
                    <span className="font-medium text-zinc-300" data-id="element-555" data-mp="39ac6plym712o">Why it matters — </span>
                    {check.why}
                  </p>
                  {check.status !== 'pass' && <p className="rounded-lg border border-[#d97742]/20 bg-[#d97742]/[0.07] px-3 py-2 text-[12.5px] leading-relaxed text-[#e8b98f]" data-id="element-556" data-mp="30c0jltwyilez">
                      <span className="font-medium text-[#e8a369]" data-id="element-557" data-mp="2qlff5pulqmo5">Do this — </span>
                      {check.fix}
                    </p>}
                </div>}
            </li>;
      })}
      </ul>
    </Card>;
}